<div class="carousel-container">
  <app-image-carousel
    delay="3000"
    [automatic]="true"
    [needButtons]="false"
    [needIndicators]="false"
    [fullImage]="true"
    [carouselItems]="carouselItems"
  >
  </app-image-carousel>
</div>
<div class="main-page-nav px-3">
  <div class="row justify-content-around px-3">
    <div class="sub-nav-item">
      <div
        class="col-md p-3 mx-2 text-center"
        routerLink="/main/organizations"
        routerLinkActive="active"
      >
        <i class="fas fa-users"></i>
        <p class="mt-3">Civil szervezetek</p>
      </div>
    </div>
    <div class="sub-nav-item">
      <div
        class="col-md p-3 mx-2 text-center"
        routerLink="/main/news"
        routerLinkActive="active"
      >
        <i class="fas fa-newspaper"></i>
        <p class="mt-3">Híreink</p>
      </div>
    </div>
    <div class="sub-nav-item">
      <div
        class="col-md p-3 mx-2 text-center"
        routerLink="/main/competitions"
        routerLinkActive="active"
      >
        <i class="fas fa-calendar-check"></i>
        <p class="mt-3">Pályázatok</p>
      </div>
    </div>
    <div class="sub-nav-item">
      <div
        class="col-md p-3 mx-2 text-center"
        routerLink="/main/administration"
        routerLinkActive="active"
      >
        <i class="fab fa-internet-explorer"> </i>
        <p class="mt-3">E-ügyintézés</p>
      </div>
    </div>
    <div class="sub-nav-item">
      <div
        class="col-md p-3 mx-2 text-center"
        routerLink="/main/community"
        routerLinkActive="active"
      >
        <i class="fas fa-user-friends"> </i>
        <p class="mt-3">Közösségi Színtér</p>
      </div>
    </div>
  </div>
</div>
<div
  class="content my-3"
  [@routeAnimations]="
    o && o.activatedRouteData && o.activatedRouteData['animation']
  "
>
  <router-outlet #o="outlet"></router-outlet>
</div>
